import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, FormattedHTMLMessage } from 'react-intl';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { object } from 'prop-types';
import { streams } from '../../../../services/ApiService';
import {
  startSetStreamSettings,
  startSetGlobalPostback,
  startEditGlobalPostback,
} from '../../../../actions/streams';
import Layout from '../../../../components/Layout/Layout';
import GlobalPostbackForm from '../../components/postback/GlobalPostbackForm';
import WithAlert from '../../../../hoc/WithAlert';
import { iFMessage, FMessage } from '../../../../hoc/IntlComponents';
import PostbackLogsTable from '../../components/postback/PostbackLogsTable';
import { startSetFaqPage } from '../../../../actions/faq';
import Card from '../../../../components/Card/Card';




class GlobalPostbackPage extends Component {
  static propsTypes = {
    settings: object.isRequired,
  };

  state = {
    loading: false,
    response: null,
    modal: false,
    errors: {},
  };

  componentDidMount() {
    this.setState(() => ({ loading: true }));

    this.props
      .startSetStreamSettings()
      .then(() => this.props.startSetGlobalPostback())
      .then(() => this.setState(() => ({ loading: false })))
      .catch(({ response = {} }) => this.handleError(response))
      .then(() => this.props.startSetFaqPage(183))
  }

  checkPostback = postback => {
    this.setState(() => ({ loading: true }));

    streams
      .checkPostback(postback)
      .then(({ items }) => {
        const data = items[0];

        this.setState(() => ({
          loading: false,
          response: data.response,
        }));

        this.toggleModal();
      })
      .catch(({ response = {} }) => this.handleError(response));
  };

  handleError = response => {
    this.setState(() => ({ loading: false }));

    if (response.data && response.data.error) {
      const { message: error } = response.data.error;

      this.props.showAlert({
        alertType: 'danger',
        message: error.message,
        dismissable: false,
        closeInSeconds: 3,
      });
    }
  };

  handleSubmit = data => {
    const { intl } = this.props;
    this.setState(() => ({ loading: true }));
    this.props
      .startEditGlobalPostback(data)
      .then(() => {
        this.setState(() => ({ loading: false }));

        this.props.showAlert({
          alertType: 'success',
          message: iFMessage({ intl, id: 'postback.global.saved' }),
          dismissable: false,
          closeInSeconds: 3,
        });
      })
      .catch(({ response = {} }) => this.handleError(response));
  };

  toggleModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  };

  render() {
    const { settings, match, theme, faq } = this.props;
    const { modal, response, loading } = this.state;

    return (
      <Layout className='global-postback-page' formattedTitle="postback.global.title">
        <Layout.Col>
          <h3 className='page-title'>
            <FMessage id="postback.global.title.theme_3" />
          </h3>
        </Layout.Col>
        <Layout.Col>
          <Card className='postback-useful-info'>
            <Card.Body>
              <FormattedHTMLMessage tagName="div" id='postback.useful-info' />
            </Card.Body>
          </Card>

          <GlobalPostbackForm
            page={faq.page}
            theme={theme}
            loading={loading}
            postback={settings.globalPostback}
            statuses={settings.postBackStatuses}
            onCheckPostback={this.checkPostback}
            onSubmit={this.handleSubmit}
          />
          <PostbackLogsTable match={match} />
        </Layout.Col>

        <Modal className='postback-response-modal' size="lg" isOpen={modal} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>
            <FormattedMessage id="flow.modal.postback-response" defaultMessage="Postback reponse" />
          </ModalHeader>
          <ModalBody>
            <pre>{response}</pre>
          </ModalBody>
        </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.streams.settings,
  theme: state.webmaster.profile.theme,
  faq: state.faq
});
const mapDispatchToProps = dispatch => ({
  startSetStreamSettings: () => dispatch(startSetStreamSettings()),
  startSetFaqPage: faqId => dispatch(startSetFaqPage(faqId)),
  startSetGlobalPostback: () => dispatch(startSetGlobalPostback()),
  startEditGlobalPostback: data => dispatch(startEditGlobalPostback(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithAlert(injectIntl(GlobalPostbackPage)));
